import { Clock } from 'lucide-react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

interface MarketClosedDialogProps {
  open: boolean;
  symbol: string;
  side: string;
  quantity: string;
  onQueue: () => void;
  onCancel: () => void;
}

export function MarketClosedDialog({
  open,
  symbol,
  side,
  quantity,
  onQueue,
  onCancel,
}: MarketClosedDialogProps) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={(v) => {
        if (!v) onCancel();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <Clock className="h-5 w-5 text-yellow-500" />
            Market is Closed
          </AlertDialogTitle>
          <AlertDialogDescription>
            The market is currently closed. Would you like to queue this order ({side.toUpperCase()}{' '}
            {quantity} {symbol}) for execution at market open?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onQueue}>Queue for Market Open</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
